// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#react-header-app {
  position: relative;
  z-index: 20;
}

#main-footer {
  display: block;
  position: relative;
}

#react-bottom-nav {
  position: sticky;
  bottom: 0;
  z-index: 10;
}



`, "",{"version":3,"sources":["webpack://./src/loader/css/themes.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb","sourcesContent":["#react-header-app {\n  position: relative;\n  z-index: 20;\n}\n\n#main-footer {\n  display: block;\n  position: relative;\n}\n\n#react-bottom-nav {\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
